export const SITE = {
  baseUrl: 'https://www.bubblesoccer.lumiron.ch',
  name: 'Lumiron - Bubble Soccer',
  brand: 'Lumiron',
  titleSuffix: 'Lumiron',
  locale: 'de_CH',
  geoRegion: 'CH-SG',
  geoPlacename: 'Diepoldsau',
  geoLatitude: 47.3833,
  geoLongitude: 9.65,
  serviceRadiusMeters: 50_000,
  defaultImage: 'https://res.cloudinary.com/lumiron/image/upload/f_auto,q_auto,w_1200/bubbles-in-garden',
} as const;
